import { ReactNode, useState } from 'react';

import { ModalMode } from '@app-velocity/message-bus';

import { ModalWrapperContext } from './context/ModalWrapperContext';

export type ModalProviderProps = {
  children: ReactNode;
};

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [isWrapperVisible, setWrapperVisible] = useState(false);
  const [openedModalId, setOpenedModalId] = useState('');
  const [modalData, setData] = useState<Record<string, unknown>>({});
  const [mode, setMode] = useState<ModalMode>('default');
  const [closable, setClosable] = useState<boolean>(true);

  const setModalData = (modalId: string, data: unknown) => {
    setData((prev) => ({
      ...prev,
      [modalId]: data,
    }));
  };

  const openModal = (modalId: string) => {
    setWrapperVisible(true);
    setOpenedModalId(modalId);
  };

  const closeModal = () => {
    setWrapperVisible(false);
    setOpenedModalId('');
  };

  return (
    <ModalWrapperContext.Provider
      value={{
        openModal,
        closeModal,
        setModalData,
        setMode,
        setClosable,
        isWrapperVisible,
        openedModalId,
        modalData,
        mode,
        closable,
      }}
    >
      {children}
    </ModalWrapperContext.Provider>
  );
};
